if (!customElements.get('hoculus-required-tax')) {
    class HoculusRequiredTax extends HTMLElement {
        constructor() {
            super();

            this.optionsInputs = this.querySelectorAll('input[type="radio"]:not(#choice-tax-option__required)');
            this.taxWrapper = this.querySelector('.hoculus-required-tax__field-tax-wrap');
            this.noTaxWrapper = this.querySelector('.hoculus-required-tax__field-no-tax-wrap');
            this.taxIdCodeInput = this.querySelector('input[name="attributes[Codice Fiscale]"]');
            this.selectCountryInput = this.querySelector('select[name="attributes[Codice Estero]"]');
            this.privacyCheckboxInput = this.querySelector('input[name="hoculus-privacy-field"]');
            this.taxForeignWrapper = this.querySelector('.hoculus-required-tax__field-no-tax-wrap');
            this.allForeignCodesOptions = JSON.parse(document.getElementById('hoculus-foreign-codes').textContent);
            this.preselected = this.dataset.preselected;
            this.selected = this.preselected === "true" ? this.dataset.selected : null;

            this.errorCodeMissingMessage = this.dataset.errorsCodeMissing;
            this.errorCodeInvalidMessage = this.dataset.errorsCodeInvalid;
            this.errorPrivacyMissingMessage = this.dataset.errorsPrivacyMissing;
            this.errorNoCountrySelected = this.dataset.errorsNoCountrySelected;
        }

        async checkPresenceOfCartItems() {
            const updateDisplay = (count) => {
                this.style.display = count > 0 ? 'block' : 'none';
            }

            const responseFromCart = await fetch('/cart.js');

            if(responseFromCart.ok) {
                const cartData = await responseFromCart.json();
                updateDisplay(cartData.item_count);
            }

            ['theme:product:add', 'theme:line-item:change'].forEach((cartEvent) => {
                document.addEventListener(cartEvent, (e) => {
                    updateDisplay(e.detail.cartItemCount);
                });
            });
        }

        connectedCallback() {
            this.initialState();
            this.mountOptionsSelect();
            this.checkPresenceOfCartItems();
            this.handleFieldsState();
            this.showFieldsOnChange();

            this.taxIdCodeInput.addEventListener('input', () => this.validateAll());
            this.taxIdCodeInput.addEventListener('invalid', () => this.validateAll());

            this.optionsInputs.forEach(input => input.addEventListener('change', () => this.validateAll()));

            this.privacyCheckboxInput.addEventListener('change', () => this.validateAll());
            this.selectCountryInput.addEventListener('change', () => this.validateAll());

            this.validateAll();
        }
        initialState() {
            if (this.preselected !== "true") return;

            this.optionsInputs.forEach(input => {
                if (input.id === this.selected) {
                    input.checked = true;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }

        mountOptionsSelect() {
            let lastOption = this.selectCountryInput.querySelector('option');

            Object.values(this.allForeignCodesOptions).forEach((value) => {
                const valueOptionName = value.name
                const valueOptionCode = value.code

                const customValue = valueOptionCode.toString().concat(' - ').concat(valueOptionName);
                const costumOption = document.createElement('option');
                costumOption.setAttribute('value', customValue);
                costumOption.innerHTML = valueOptionName;

                lastOption.insertAdjacentElement('afterend', costumOption);
                lastOption = costumOption;
            })

        }

        handleFieldsState() {
            const selectedOption = Array.from(this.optionsInputs).find(input => input.checked);
            selectedOption && selectedOption.id === 'choice-tax-option-primary' ? this.taxWrapper.classList.add('active') : this.taxWrapper.classList.remove('active');
            selectedOption && selectedOption.id === 'choice-tax-option-secondary' ? this.noTaxWrapper.classList.add('active') : this.noTaxWrapper.classList.remove('active');
        }

        showFieldsOnChange() {
            this.optionsInputs.forEach((input) => {
                input.addEventListener('change', (event) => {
                    switch (event.target.id) {
                        case 'choice-tax-option-primary':
                            this.taxWrapper.classList.add('active');
                            this.noTaxWrapper.classList.remove('active');
                            break;
                        case 'choice-tax-option-secondary':
                            this.noTaxWrapper.classList.add('active');
                            this.taxWrapper.classList.remove('active');
                            break;
                        default:
                            this.taxWrapper.classList.remove('active');
                            this.noTaxWrapper.classList.remove('active');
                    }
                });
            });
        }

        validateAll() {
            Array.from(this.optionsInputs).some(input => input.checked) ? this.querySelector('#choice-tax-option__required').checked = true : null
            const selectedOption = Array.from(this.optionsInputs).find(input => input.checked)?.id;
            this.privacyCheckboxInput.checked ? this.privacyCheckboxInput.setCustomValidity('') : this.privacyCheckboxInput.setCustomValidity(this.errorPrivacyMissingMessage);  

            switch (selectedOption) {  
                case 'choice-tax-option-primary':  
                    this.taxIdCodeInput.required = true;  
                    this.selectCountryInput.required = false;  
                    this.selectCountryInput.setCustomValidity('');  
                    if (this.isValueEmpty(this.taxIdCodeInput.value)) this.taxIdCodeInput.setCustomValidity(this.errorCodeMissingMessage);  
                    else if (!this.isValueConform(this.taxIdCodeInput.value)) this.taxIdCodeInput.setCustomValidity(this.errorCodeInvalidMessage);  
                    else this.taxIdCodeInput.setCustomValidity('');  
                    break;  
            
                case 'choice-tax-option-secondary':  
                    this.taxIdCodeInput.setCustomValidity('');  
                    this.taxIdCodeInput.required = false;  
                    if (!this.selectCountryInput.value) this.selectCountryInput.setCustomValidity(this.errorNoCountrySelected);  
                    else this.selectCountryInput.setCustomValidity('');  
                    break;  
                default:  
                    this.taxIdCodeInput.setCustomValidity('');  
                    this.taxIdCodeInput.required = false;  
                    this.selectCountryInput.setCustomValidity('');  
                    this.selectCountryInput.required = false;  
                    break;  
            }  
        }


        isValueEmpty(value) {
            return value.trim() === '';
        }

        isValueConform(value) {
            return /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/.test(value);
        }
    }

    customElements.define('hoculus-required-tax', HoculusRequiredTax);
}
